<template>
  <div class="loading-overlay">
    <div class="overlay" v-show="isActive">
      <div class="loading-text text-large">
        <span v-html="loadingText"></span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      default: false,
    },
    default: {
      default: false
    }
  },
  created() {
    this.isActive = this.default
  },
  data() {
    return {
      r: 1,
      loadingText: 'Loading...',
      isActive: true,
    }
  },
  watch: {
    'show': function (val) {
      this.isActive = val
    },
    'isActive': function () {
      this.animate()
    }
  },
  methods: {
    animate() {
      if (!this.isActive) {
        this.loadingText = 'Loading...'
        this.r = 0
        return
      }

      this.loadingText = 'Loading' + '.'.repeat(this.r) + '&nbsp;'.repeat(4 - this.r)
      this.r++
      this.r = this.r === 4 ? 0 : this.r

      setTimeout(() => {
        this.animate()
      }, 250)
    },
  },
}
</script>
<style lang="scss">
.loading-overlay {
  position: relative;

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.9);
    z-index: 3;
    display: flex;

    .loading-text {
      align-self: center;
      width: 100%;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/invoices2/LoadingOverlay.vue